import React, { useState } from "react";
import styles from "./PreviewText.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";

const PreviewText = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {" "}
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>

          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.inputText}>
          <input className={styles.textField} placeholder="Text" />
        </div>
      </div>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PreviewText;
